'use strict';

export default class ManagerController {
  /*@ngInject*/

  constructor ($http, $cookies, ManageGroup, Auth, $scope, $timeout, $uibModal) {
    this.$http = $http;
    this.$cookies = $cookies;
    this.ManageGroup = ManageGroup;           //inject as a service
    this.Auth = Auth;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;

    //Define the data variables here
    this.groups;
    this.users;
    this.physicians;
    this.patients;
    this.groupFeedLimit = 10;
    this.patientFeedLimit = 10;
    this.physicianFeedLimit = 10;
    this.groupCurrentPage = 1;
  }

  $onInit () {
    console.log('SafeStart Admin Controller service....');
    let promises = [];

    let getGroupPromise = this.ManageGroup.getGroups()
      .then(response => {
        this.groups = response;
        //Set the total number of users per group here
        return response;
      });

    let userPromise = this.ManageGroup.getUsers()
      .then(response => {
        this.users = response;
        return response;
      });

    let patientPromise = this.ManageGroup.getPatients()
      .then(response => {
        this.patients = response;
        return response;
      });

    promises.push(getGroupPromise, userPromise, patientPromise);

    return Promise.all(promises)
      .then(()=>{
        return this.physicianAnalytics();
      })
      .then(() => {
        this.physicianFeed = this.physicianFeedAnalytics();
      })
      .then(() => {
        this.patientFeed = this.patientFeedAnalytics();
      })
      .then(() => {
        /*To bind the code asynchronously*/
        return this.$scope.$applyAsync();
      });
  }

  physicianAnalytics = () => {
    return Object.keys(this.groups).map((group, key) => {
      this.groups[group].totalUsers = 0
      Object.keys(this.users).map((user, key) => {
        if ((this.groups[group]._id == this.users[user].group) && (this.users[user].staffRole !== 'user' && this.users[user].staffRole !== undefined)) {
          this.groups[group].totalUsers++
        }
      })
    })
  }

  physicianFeedAnalytics = () => {
    let feed = []
    this.users.map((user, key) => {
      if(user.group && user.staffRole && user.staffRole !== 'user' ) {
        let createdAt = new Date(user.createdAt);
        Object.keys(this.groups).map((group, key) => {
          if(this.groups[group]._id == user.group) {
            feed.push(`The User ${user.firstName} ${user.lastName} with staff role ${user.staffRole} was added to the group ${this.groups[group].name} on date ${createdAt.toLocaleString()}`);
          }
        });
      }
    })
    return feed;
  }

  patientFeedAnalytics = () => {
    let feed = []
    this.patients.map((patient, key) => {
      if(patient.group) {
        let createdAt = new Date(patient.createdAt);
        Object.keys(this.groups).map((group, key) => {
          if(this.groups[group]._id == patient.group) {
            feed.push(`The Patient ${patient.firstName} ${patient.lastName} was added to the group ${this.groups[group].name} on ${(createdAt.toLocaleString())}`);
          }
        })
      }
    })
    return feed;
  }

  openModal = (params, data) => {
    let template;
    if(params == 'createGroup') {
      template = require('../../../components/user-modification-modal/create-group-modal.html')
    }
    else if(params == 'mergeGroup') {
      template = require('../../../components/user-modification-modal/merge-group-modal.html')
    }
    var modalInstance = this.$uibModal.open({
//      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: template,
      controller: 'UserModificationModalController',
      controllerAs: 'vm',
//      size: size,
//      appendTo: parentElem,
      resolve: {
        editUser: () => {
          return data;
        }
      }
    });
    modalInstance.result.then( () => {
      this.ManageGroup.getGroups()
        .then((response) => {
          this.groups = response;
        })
        .then(() => {
          return this.physicianAnalytics();
        })
        .then(() => {
          this.physicianFeed = this.physicianFeedAnalytics();
        })
        .then(() => {
          this.patientFeed = this.patientFeedAnalytics();
        })
        .then(() => {
          /*To bind the code asynchronously*/
          return this.$scope.$applyAsync();
        });
    }, function () {
      console.log('Create Group Modal dismissed');
    })
  }
}




// WEBPACK FOOTER //
// ./client/app/admin/manager/manager.controller.js